'use strict';

module.exports = require('react').addons.PureRenderMixin;



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.33/react-addons-pure-render-mixin.js
// module id = 18
// module chunks = 171